<template>
  <div class="game_main">
    <img class="game_img" :src="datas.homeImg" alt="">
    <div class="game_bg" :style="gameBgStyle">
      <div class="txt_name">{{datas.name}}</div>
      <div class="txt_tips">{{datas.text}}</div>
      <div class="txt_tips">{{datas.tips}}</div>
      <div>
        <img class="down_but" src="@/assets/game/but_down.png" alt="" @click="onClickDown('down_now')">
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'GameAbout',
  components: {
  },
  props: [
    'datas', 'opts'
  ],
  data: () => {
    return {
    }
  },
  methods: {
    onClickDown (vtype) {
      this.$emit('events', 'down_now', this.datas)
    }
  },
  computed: {
    gameBgStyle () {
      return {
        'background-image': 'url(' + require('@/assets/game/bg.png') + ')'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.game_main {
  padding: 0 0rem;
}
.game_img {
  display: block;
  margin: auto;
  width: 100%;
}
.game_bg {
  padding: 0.3rem 1.6rem;
  color: #fff;
  background-repeat: no-repeat;
   background-size: 100% 100%;
}
.txt_name {
  font-size: 0.6rem;
  font-weight: bold;
  line-height: 1.8rem;
}
.txt_tips {
  font-size: 0.4rem;
  font-weight: lighter;
  text-align: left;
}
.down_but {
  margin: 0.3rem;
  margin-top: 0.6rem;
  width: 5.3rem;
}
</style>
